import React, { useEffect } from "react";
import PropTypes from "prop-types";
import "./Plus-Icon.scss";

const PlusIcon = ({ func, active, disabled, projectId = 0 }) => {
  const setZIndex = () => {
    let plusIcon = document.getElementById("plusIconFixed_" + projectId);
    if (plusIcon) {
      if (active) plusIcon.style.cssText = `z-index : 99`;
      else plusIcon.style.cssText = `z-index : 3`;
    }
  }

  useEffect(() => {
    if (projectId > 0) setZIndex();
  }, [active]);

  return (
    <button
      className={active ? 'plus-icon plus-icon-active' : `plus-icon`}
      onClick={() => func()}
      disabled={disabled}
      style={disabled ? { pointerEvents: "none" } : {}}
    >
      <div className={`plus-icon-plus-sign`}></div>
    </button>
  );
};

PlusIcon.propTypes = {
  func: PropTypes.func,
  active: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  projectId: PropTypes.number
};

export default PlusIcon;
